import React, { useEffect } from 'react';
// Store
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { checkIsLoading } from 'src/utils/types/statuses';
import { fetchEmailTemplates } from 'src/store/lists/emailTemplates/asyncThunk';
import {
  checkCanLoadEmailTemplates,
  getEmailTemplatesForSelect,
} from 'src/store/lists/emailTemplates/helpers';

// UI
import { BaseSelect } from '../../../common';

type PEmailTemplatesSelect = {
  label?: string;
  [key: string]: any;
};

export const EmailTemplatesSelect: React.FC<PEmailTemplatesSelect> = (
  props,
) => {
  const { label = 'Choose template:', ...otherProps } = props as any;
  const dispatch = useDispatch();
  useEffect(() => {
    checkCanLoadEmailTemplates(() => dispatch(fetchEmailTemplates()));
  }, [dispatch]);
  const { status } = useSelector((state: RootState) => state.emailTemplates);
  const emailTemplates = useSelector(getEmailTemplatesForSelect);
  return (
    <BaseSelect
      options={emailTemplates}
      label={label}
      loading={checkIsLoading(status)}
      {...otherProps}
    />
  );
};
